import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers";
import FormControl from "@mui/material/FormControl";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, Fragment } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import {
  TextField,
  LoadingButton,
  CaptchaDisplay,
} from "./../../../components";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import pages from "./../../../constants/pages";
import convertNormalDate from "./../../../utils/convertNormalDate";
import { useAlert, useAxiosV2, useAxios } from "./../../../hooks/";

import { MdDocumentScanner } from "react-icons/md";

import AadharCardBack from ".././assests/AadharCard.svg";
import VerificationPopup from "../../user step components/VerificationPopup";
import { getVisitorFaceData } from "../../../utils/getVisitorFaceData";
import { HourglassEmpty } from "@mui/icons-material";

const MyComponent = ({
  visitorId,
  setVerificationFailedCount,
  setVerification,
  OuterBox2,
  setIdentityType,
  OuterPaper,
  errorUrlS,
  entityDetails,
  documentsList,
  handleIdentityTypeChange,
  selectDocuments,
  setSelectDocuments,
}) => {
  const axios = useAxios();

  const { alert } = useAlert();

  const location = useLocation();

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { visitorData } = useSelector((state) => state.memberDetails);
  const [isMasked, setIsMasked] = useState(true);

  const [open, setOpen] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [ocrLoading, setOCRLoading] = useState(false);
  const [CaptchaError, setCaptchaError] = useState(false);
  const [errorStep, setErrorStep] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [errorUrl, setErrorUrl] = useState(errorUrlS || "");
  const [stopStep, setStopStep] = useState(6);

  const [dlStack, setDlStack] = useState([]);
  const [dlMaskStack, setDlMaskStack] = useState([]);

  const queryParams = new URLSearchParams(location.search);

  const entityId = queryParams.get("entity_id");
  const bookingId = queryParams.get("booking_id");

  const userTypeID = queryParams.get("user_type_id");
  const docFace = queryParams.get("doc_face");
  const popUp = queryParams.get("popup");
  const autoConsent = queryParams.get("auto_consent");
  const indepentent = queryParams.get("indepentent");

  const digiLockerID = queryParams.get("id");
  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomCaptcha = "";
    for (let i = 0; i < 6; i++) {
      randomCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(randomCaptcha);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleGoBack = () => {
    // setIdentityType("");
    // setVerification(false);
    digiLockerID ? navigate(errorUrl) : navigate(-1);
  };

  function handleVerifyDrivingLicence(values) {
    if (values.captchaInput !== captcha) {
      setCaptchaError(true);
      return;
    }

    const localStorageData = { ...localStorage };

    const digipassDataKey = Object.keys(localStorageData).filter((item) => {
      return item.includes(visitorId);
    });

    setLoading(true);
    axios({
      url: "/event/govt-api/verify-dl",
      method: "POST",
      disableRedirect: true,
      data: {
        dl_no: values.dl_number,
        dob: convertNormalDate(values.dob),
        name: " ",
        visitor_id: visitorId,
        face_data: localStorage.getItem(digipassDataKey[0]),
        document_verification: true,
        is_encrypted_face: true,
        booking_id: bookingId,
        entity_id: entityId,
        user_type_id: userTypeID,
        auto_consent: autoConsent,
      },
    })
      .then((response) => {
        if (response.status) {
          setOpen(true);

          if (autoConsent == "true") {
            setStopStep(5);
            let key = visitorId;
            localStorage.setItem(key, response.data.encrypted_face_data || "");

            axios({
              url: "event/visitor/save-consent",
              method: "POST",
              data: {
                visitor_id: visitorId,
                booking_id: bookingId,
                entity_id: entityId,
                user_type_id: userTypeID,
                face_data: response.data.encrypted_face_data,
                consent_for: ["face", "contact-details"],
              },
              disableRedirect: true,
            }).then((response) => {
              if (response.status) {
                // dispatch(
                //   alert({
                //     type: "success",
                //     message: "DL Verified successfully.",
                //   })
                // );
                setStopStep(6);
                setLoading(false);
              }
            });
          } else {
            setLoading(false);

            // dispatch(
            //   alert({
            //     type: "success",
            //     message: "DL Verified successfully.",
            //   })
            // );

            let key = visitorId;
            localStorage.setItem(key, response.data.encrypted_face_data || "");
            setOpen(true);
          }
        } else {
          setLoading(false);

          if (response.data.next_url) {
            setErrorStep(response.data.step);
            setErrorUrl(response.data.next_url);
            setOpen(true);
            setErrorMsg(response.displayMessage);
          }
          // setVerificationFailedCount((prevCount) => prevCount + 1);
          dispatch(
            alert({
              type: "error",
              message: response.message.displayMessage,
            })
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        setVerificationFailedCount((prevCount) => prevCount + 1);
      });
  }

  const onSubmit = async (values) => {
    try {
      handleVerifyDrivingLicence(values);
    } catch (error) {
      dispatch(
        alert({
          type: "error",
          message: error,
        })
      );
    }
  };

  const validationSchema = Yup.object().shape({
    dl_number: Yup.string()
      .matches(/^[a-zA-Z0-9]+$/, "Special characters are not allowed")
      .required("Dl Number is required"),
    dob: Yup.string().required("Dob is required"),
    captchaInput: Yup.string()
      .required("Captcha is required")
      .test("captcha-match", "Captcha does not match", function (value) {
        return value === captcha;
      }),
  });

  const formik = useFormik({
    initialValues: {
      dl_number: "",
      dob: "",
      captchaInput: "",
    },
    validationSchema,
    onSubmit,
  });

  const getDisplayValue = () => {
    return isMasked ? dlMaskStack.join("") : dlStack.join("");
  };

  const handleDlNumberChange = (event) => {
    const dlString = event?.target?.value?.slice(-1);

    const key = dlString;
    let updatedDl = [...dlStack];
    let updatedMask = [...dlMaskStack];

    if (event.target.value.length < updatedDl.length) {
      // Handle backspace
      updatedDl.pop();
      updatedMask.pop();
    } else {
      const cleanKey = key?.toUpperCase();
      const dlLength = updatedDl.filter((i) => i !== " ").length;

      // Allow only letters + numbers
      if (
        cleanKey &&
        /^[A-Z0-9]$/.test(cleanKey) &&
        dlLength < 15 // DL number max length (without spaces)
      ) {
        // Insert spaces at correct positions -> 2 | 4 | 8
        // if (dlLength === 2 || dlLength === 4 || dlLength === 8) {
        //   updatedDl.push(" ");
        //   updatedMask.push(" ");
        // }

        updatedDl.push(cleanKey);

        // Masking logic: hide unique number (last 7 digits)
        updatedMask.push(dlLength >= 9 ? cleanKey : "X");
      }
    }

    setDlStack(updatedDl);
    setDlMaskStack(updatedMask);

    // Raw DL without spaces
    const rawValue = updatedDl.join("").replace(/\s/g, "");
    formik.setFieldValue("dl_number", rawValue);
  };

  const handleDlPaste = (event) => {
    event.preventDefault();

    // Get only alphanumeric characters (DLs usually contain letters + numbers)
    const pasteData = event.clipboardData
      .getData("text")
      .replace(/[^a-zA-Z0-9]/g, "");
    if (!pasteData) return;

    // Limit to 15 chars (DL format varies, but keeping it consistent with your max logic)
    const cleanValue = pasteData.slice(0, 15).toUpperCase();

    const updatedDl = [];
    const updatedMask = [];

    for (let i = 0; i < cleanValue.length; i++) {
      // Insert spaces at positions 2, 4, 8 (same as your typing logic)
      // if (i === 2 || i === 4 || i === 8) {
      //   updatedDl.push(" ");
      //   updatedMask.push(" ");
      // }

      updatedDl.push(cleanValue[i]);

      // Masking: first 8 chars = "X", rest = real value
      updatedMask.push(i >= 8 ? cleanValue[i] : "X");
    }

    setDlStack(updatedDl);
    setDlMaskStack(updatedMask);

    // Raw DL without spaces
    formik.setFieldValue("dl_number", cleanValue);
  };

  const handleDlInput = (event) => {
    let value = event.target.value;

    // Keep only alphanumeric
    value = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    // Limit length
    value = value.slice(0, 15);

    const updatedDl = [];
    const updatedMask = [];

    for (let i = 0; i < value.length; i++) {
      updatedDl.push(value[i]);
      updatedMask.push(i >= 8 ? value[i] : "X");
    }

    setDlStack(updatedDl);
    setDlMaskStack(updatedMask);

    // Set raw value for formik
    formik.setFieldValue("dl_number", value);
  };

  const adjustColor = (hex) => {
    if (!hex) return "#c4c412";

    // Remove '#' if present
    hex = hex.replace("#", "");

    // Convert shorthand hex (like #fc0)
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((x) => x + x)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Check brightness
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // If too bright, darken it
    if (brightness > 180) {
      const darken = (val) => Math.max(0, val - 60);
      return `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})`;
    }

    return `#${hex}`;
  };

  return (
    <Fragment>
      <Grid item container>
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <div
                  style={{
                    // width: "95vw",
                    position: "relative",
                    height: "40vh",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      position: "relative",
                      zIndex: "999999",
                      top: "47%",
                      left: "2%",
                      width: "96.25%",
                    }}
                  >
                    <Typography
                      variant="h3"
                      fontWeight={900}
                      sx={{ marginTop: "7.5px" }}
                    >
                      {"Verify Profile Using Driving Licence"}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight={500}
                      sx={{ marginTop: "7.5px", color: "#00000099" }}
                    >
                      {/* {"Please Enter your Driving Licence Details"} */}
                      {`Please enter your Driving Licence Details to verify your profile.`}
                    </Typography>

                    <TextField
                      select
                      size="small"
                      style={{
                        // marginBottom: "30px",
                        marginTop: "20px",
                        background: "white",
                      }}
                      value={selectDocuments}
                      onChange={(e) => {
                        setSelectDocuments(e.target.value);
                        handleIdentityTypeChange(e.target.value);
                      }}
                    >
                      {documentsList?.map((item, index) => (
                        <MenuItem key={item.id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    {documentsList?.filter((item) => item.document_id == 2)[0]
                      ?.display && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.2,
                          backgroundColor: documentsList?.filter(
                            (item) => item?.document_id == 2
                          )[0]?.color,
                          color: "#060606ff", // dark gold text
                          padding: "8px 14px",
                          borderRadius: "4px",
                          borderLeft: `4px solid ${adjustColor(
                            documentsList?.filter(
                              (item) => item?.document_id == 2
                            )[0]?.color
                          )}`, // light yellow left bar
                          width: "fit-content",
                          boxShadow: `0 0 0 1px ${
                            documentsList?.filter(
                              (item) => item?.document_id == 2
                            )[0]?.color
                          } inset`, // subtle border like in screenshot
                        }}
                      >
                        <HourglassEmpty sx={{ fontSize: 18 }} />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          {
                            documentsList?.filter(
                              (item) => item?.document_id == 2
                            )[0]?.message_note
                          }
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                  <img
                    style={{
                      height: "35vh",
                      position: "absolute",
                      top: "0px",
                    }}
                    src={AadharCardBack}
                  />
                </div>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        container
        mt={
          documentsList?.filter((item) => item?.document_id == 2)[0]?.display
            ? 7.5
            : 0
        }
      >
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2 style={{ width: "100%" }}>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <Grid
                  item
                  padding={"2%"}
                  mt={2}
                  // sx={{ "@media (min-width:1000px)": { width: "50%" } }}
                  alignContent={"center"}
                >
                  <form>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "700", marginBottom: "17.5px" }}
                    >
                      Enter Driving Licence Number
                      <span
                        style={{
                          color: "red",
                          fontWeight: "700",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <TextField
                      fullWidth
                      sx={{ marginBottom: "16px" }}
                      variant="outlined"
                      // label={
                      //   <Fragment>
                      //     <Grid container>
                      //       <Grid item xs={10}>
                      //         Enter Driving Licence Number
                      //       </Grid>
                      //     </Grid>
                      //   </Fragment>
                      // }
                      autoComplete="license-number"
                      size="small"
                      placeholder="Enter Driving Licence Number"
                      name="dl_number"
                      // value={formik.values.dl_number}
                      value={getDisplayValue()}
                      onChange={(e) => {
                        handleDlNumberChange(e);
                        // const cleanValue = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                        // formik.setFieldValue("dl_number", cleanValue);
                      }}
                      onPaste={handleDlPaste}
                      onInput={handleDlInput}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.dl_number &&
                        Boolean(formik.errors.dl_number)
                      }
                      InputProps={{
                        endAdornment: (
                          <Fragment>
                            <Tooltip>
                              <input
                                accept="image/*,application/pdf"
                                style={{ display: "none" }}
                                id="file-upload"
                                type="file"
                                // onChange={(event) => {
                                //   const fil = event.target.files[0];

                                //   setOCRLoading(true);

                                //   const form = new FormData();
                                //   form.append("file", fil);

                                //   axios({
                                //     url: "event/govt-api/ocr",
                                //     method: "POST",
                                //     data: form,
                                //     disableRedirect: true,
                                //   })
                                //     .then((response) => {
                                //       formik.setFieldValue(
                                //         "dl_number",
                                //         response.data?.data?.number || ""
                                //       );
                                //       setOCRLoading(false);

                                //       if (!response.data?.data?.number) {
                                //         dispatch(
                                //           alert({
                                //             type: "error",
                                //             message: "Please share the right documents",
                                //           })
                                //         );
                                //       }
                                //     })
                                //     .catch(() => {
                                //       setOCRLoading(false);
                                //     });
                                // }}
                              />
                              <label>
                                {isMasked ? (
                                  <VisibilityIcon
                                    style={{
                                      color: "#3936EF",
                                      fontSize: "35px",
                                      background: "white",
                                      borderRadius: "7px",
                                      padding: "3px 5px",
                                      width: "100%",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setIsMasked(false);
                                    }}
                                  />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{
                                      color: "#3936EF",
                                      fontSize: "35px",
                                      background: "white",
                                      borderRadius: "7px",
                                      padding: "3px 5px",
                                      width: "100%",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setIsMasked(true);
                                    }}
                                  />
                                )}
                              </label>
                            </Tooltip>
                          </Fragment>
                        ),
                      }}
                    />

                    <Grid item xs={12}>
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: "700", marginBottom: "17.5px" }}
                      >
                        Select Date Of Birth
                        <span
                          style={{
                            color: "red",
                            fontWeight: "700",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <FormControl fullWidth variant="outlined">
                          <DatePicker
                            // label={<>Select Date Of Birth</>}

                            autoComplete="off"
                            placeholder="Select Date Of Birth"
                            value={formik.values.dob}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.date && Boolean(formik.errors.dob)
                            }
                            onChange={(newValue) =>
                              formik.setFieldValue("dob", newValue)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                name={"dob"}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.dob &&
                                  Boolean(formik.errors.dob)
                                }
                                value={formik.values.dob}
                              />
                            )}
                            inputFormat="dd/MM/yyyy" // Set the desired date format here
                            maxDate={new Date()}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>

                    <Grid container>
                      <Grid item xs={12}>
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: "700", marginTop: "17.5px" }}
                        >
                          Enter Captcha
                          <span
                            style={{
                              color: "red",
                              fontWeight: "700",
                            }}
                          >
                            *
                          </span>
                        </Typography>
                      </Grid>

                      <Grid container>
                        <Grid item xs={7} sx={{ alignSelf: "end" }}>
                          <TextField
                            fullWidth
                            size="small"
                            margin="normal"
                            variant="outlined"
                            placeholder="Enter Captcha"
                            name="captchaInput"
                            value={formik.values.captchaInput}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.captchaInput &&
                              Boolean(formik.errors.captchaInput)
                            }
                            helperText={formik.errors.captchaInput}
                            inputProps={{
                              maxLength: 6,
                            }}
                            autoComplete="off"
                          />
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          sx={{ alignSelf: "start", padding: "0px 15px" }}
                        >
                          <CaptchaDisplay
                            captcha={captcha}
                            generateCaptcha={generateCaptcha}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container>
                      <LoadingButton
                        loading={loading}
                        onClick={formik.handleSubmit}
                        disabled={!formik.dirty || !formik.isValid}
                        style={{ margin: "10px 0px" }}
                      >
                        Verify DL
                      </LoadingButton>

                      <LoadingButton
                        onClick={handleGoBack}
                        style={{ color: "black" }}
                        backgroundColor="#F5F0E5"
                      >
                        Back
                      </LoadingButton>
                    </Grid>
                  </form>
                </Grid>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      </Grid>

      <VerificationPopup
        open={open}
        startStep={0}
        errorUrl={errorUrl}
        stopStep={stopStep}
        errorStep={errorStep}
        errorMsg={errorMsg}
        onClose={() => {
          setOpen(false);
          setErrorStep(null);
          !digiLockerID && setErrorUrl("");
          setStopStep(6);
          if (errorStep != null) {
            navigate(errorUrl);
          } else if (popUp) {
            localStorage.setItem("windowClosed", true);
            window.close();
          } else if (bookingId == -1 && docFace == "true") {
            navigate(
              `${pages.EventSuccess.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}`
            );
          } else if (bookingId == -1) {
            navigate(pages.Profile.route);
          } else {
            if (userTypeID == 1) {
              navigate(
                `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            } else if (
              userTypeID == 3 ||
              userTypeID == 4 ||
              userTypeID == 6 ||
              userTypeID == 8
            ) {
              navigate(
                `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            } else if (userTypeID == 2) {
              navigate(
                `${
                  indepentent
                    ? pages.IndependentAppointmentSummary.route
                    : pages.AppointmentSummary.route
                }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            } else if (userTypeID == 5) {
              navigate(
                `${pages.HotelSummary.path}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            }
          }
        }}
      />
    </Fragment>
  );
};

export default MyComponent;
